import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ReactQuill from "react-quill";
import api from "../../../api";
import Logo from "../../../images/logo-2.png";
import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";

export function EditSessionLink({ getVideo, setShow, videoData }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const alert = useAlert();

  const [loader, setLoader] = useState(false);
  const [inputData, setInputData] = useState({
    title: "",
    link: "",
    eventTime: "",
  });
  const [isRecording, setIsRecording] = useState(false);

  const handleSubmit = async () => {
    console.log(inputData);
    try {
      if (!inputData?.title || !inputData?.link || !inputData?.eventTime) {
        setLoader(false);
        alert.info("Please fill all fields.");
        return;
      }
      setLoader(true);
      const formData = {
        _id: videoData?._id,
        link: inputData?.link,
        title: inputData?.title || "",
        eventTime: inputData?.eventTime,
      };

      const signalResponse = await api.liveSessionedit(formData);
      console.log(signalResponse);

      if (signalResponse?.success) {
        alert.info("Video edit successfully");
        setInputData({
          title: "",
          link: "",
          eventTime: "",
        });

        setLoader(false);
        setShow(false);
        getVideo();
      } else {
        setLoader(false);
        alert.error("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert.error("Something went wrong");
    }
  };

  const handleChange = (e) => {
    // console.log(e);
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    setInputData({
      title: videoData?.title || "",
      link: videoData?.link || "",
      eventTime: videoData?.eventTime || "",
    });
  }, []);

  return (
    <>
      <div className="row mx-0 drivers-row">
        <div className="col-xl-6 col-md-7  d-flex justify-content-between pr-0">
          <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
            Edit Session
          </h4>
        </div>
      </div>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="descMainPost">
            <div className="form-group mb-3">
              <input
                type="text"
                name="title"
                className="form-control"
                onChange={handleChange}
                value={inputData?.title}
                placeholder="Add Title"
              />
            </div>

            <div className="form-group mb-3">
              <textarea
                name="link"
                id=""
                className="form-control"
                onChange={handleChange}
                value={inputData?.link}
                placeholder="Add Video Iframe"
              ></textarea>
            </div>
          </div>

          <div className="form-group mb-3">
            <input
              type="datetime-local"
              name="eventTime"
              className="form-control"
              onChange={handleChange}
              value={inputData?.eventTime}
              placeholder="Event Time"
            />
          </div>

          <div className="sendMailBtn mt-3">
            <button
              onClick={handleSubmit}
              className="btn-dark"
              disabled={isRecording}
            >
              Submit
            </button>
          </div>
        </div>
      </div>

      {loader && (
        <div className="seekoLoader">
          <div className="loader">
            <img src={Logo} alt="loader" />
          </div>
        </div>
      )}
    </>
  );
}

var Editor = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};
